import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { mobileCheck, iOS } from "./helpers/mobile-check";

window.addEventListener('load', function () {
    gsap.registerPlugin(ScrollTrigger);

    // Query all section/image pairs
    const parallaxSections = document.querySelectorAll('[data-parallax="bg-section"]');

    parallaxSections.forEach((section) => {
        const image = section.querySelector('[data-parallax="bg-image"]');

        if (image) {
            // Use ScrollTrigger instead of ticker for better mobile compatibility
            // and to prevent z-index issues on iOS Safari
            ScrollTrigger.create({
                trigger: section,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: (self) => {
                    // Only apply parallax if the section is in or near viewport
                    const rect = section.getBoundingClientRect();
                    const windowHeight = window.innerHeight;

                    // Check if section is within extended viewport bounds
                    if (rect.bottom >= -windowHeight && rect.top <= windowHeight * 2) {
                        // Clamp the movement to prevent the image from going too far
                        const movement = Math.max(-windowHeight, Math.min(windowHeight, -rect.top * 0.5));
                        gsap.set(image, {
                            y: movement,
                            force3D: true // Force hardware acceleration
                        });
                    }
                },
                // Disable on touch devices to prevent iOS Safari issues
                enabled: !mobileCheck() && !iOS() && !ScrollTrigger.isTouch
            });

            // Fallback for mobile devices - disable parallax entirely
            if (mobileCheck() || iOS() || ScrollTrigger.isTouch) {
                gsap.set(image, {
                    y: 0,
                    clearProps: "transform"
                });
            }
        }
    });
});
